var _path, _path2, _circle, _path3, _circle2, _rect, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationPermissionOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.094 9.838c0 .755-.296 1.713-.834 2.804-.533 1.077-1.268 2.218-2.07 3.319-1.588 2.177-3.393 4.138-4.27 5.056-.877-.918-2.682-2.879-4.27-5.056-.802-1.101-1.538-2.242-2.07-3.32-.539-1.09-.834-2.048-.834-2.803a7.174 7.174 0 0 1 14.348 0z",
    fill: "#F6F7F9",
    stroke: "#E74C3C",
    strokeWidth: 1.492
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.32 11h-3l-2.5 1.5h-.5l-2 1-1.5 1.5 1.5 3h5l5.5 2.5V9l-2.5 2z",
    fill: "#F6F7F9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.922,
    cy: 9.281,
    r: 3.131,
    stroke: "#E74C3C",
    strokeWidth: 1.105
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.32 16.308h-2.769l-1.07-1.071a.24.24 0 0 1-.01-.33l1.008-1.134a.24.24 0 0 1 .18-.08h6.114a.265.265 0 0 0 .256-.24c.04-.368.185-1.069.697-1.417a.217.217 0 0 1 .122-.036H21.474c.41.154 1.23.985 1.23 3.077 0 .82-.276 2.554-1.384 2.923h-3.077s-1.076-.615-1.23-1.692",
    stroke: "#E74C3C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.09,
    cy: 15.08,
    r: 0.615,
    fill: "#E74C3C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 5,
    width: 32,
    height: 14,
    rx: 4,
    fill: "#E74C3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.195 15.09c-.687 0-1.283-.147-1.79-.44a2.952 2.952 0 0 1-1.16-1.26c-.273-.547-.41-1.187-.41-1.92 0-.733.133-1.37.4-1.91a2.934 2.934 0 0 1 1.17-1.26c.507-.293 1.103-.44 1.79-.44s1.28.147 1.78.44c.507.293.893.713 1.16 1.26.273.54.41 1.177.41 1.91 0 .733-.137 1.373-.41 1.92a2.935 2.935 0 0 1-1.17 1.26c-.5.293-1.09.44-1.77.44zm0-1.03c.647 0 1.15-.223 1.51-.67.367-.447.55-1.087.55-1.92s-.183-1.47-.55-1.91c-.36-.447-.863-.67-1.51-.67-.653 0-1.163.223-1.53.67-.36.44-.54 1.077-.54 1.91s.18 1.473.54 1.92c.367.447.877.67 1.53.67zm5.437 1a.636.636 0 0 1-.47-.18.657.657 0 0 1-.17-.47V8.56c0-.193.054-.343.16-.45.114-.107.267-.16.46-.16h3.51c.407 0 .61.173.61.52 0 .34-.203.51-.61.51h-2.86v1.92h2.66c.407 0 .61.173.61.52 0 .34-.203.51-.61.51h-2.66v2.48c0 .193-.056.35-.17.47a.602.602 0 0 1-.46.18zm5.809 0a.636.636 0 0 1-.47-.18.656.656 0 0 1-.17-.47V8.56c0-.193.053-.343.16-.45.113-.107.267-.16.46-.16h3.51c.407 0 .61.173.61.52 0 .34-.203.51-.61.51h-2.86v1.92h2.66c.407 0 .61.173.61.52 0 .34-.203.51-.61.51h-2.66v2.48c0 .193-.057.35-.17.47a.603.603 0 0 1-.46.18z",
    fill: "#F6F7F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPermissionOff);
export default __webpack_public_path__ + "static/media/location-permission-off.51ae43d7.svg";
export { ForwardRef as ReactComponent };